// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AiOverviewsWhatChangedInSearch2026RouteImport } from './routes/ai-overviews-what-changed-in-search-2026'
import { Route as AiSearchOptimizationGuideRouteImport } from './routes/ai-search-optimization-guide'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CoreWebVitals2026RouteImport } from './routes/core-web-vitals-2026'
import { Route as DallasSeoCaseStudyRouteImport } from './routes/dallas-seo-case-study'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GeoSuccessMatrixExplainedRouteImport } from './routes/geo-success-matrix-explained'
import { Route as HowToRankInAiOverviewsRouteImport } from './routes/how-to-rank-in-ai-overviews'
import { Route as HowWeTurnedAroundCarageAutoRouteImport } from './routes/how-we-turned-around-carage-auto'
import { Route as IndustriesRouteImport } from './routes/industries'
import { Route as LocalSeoInAMapPackThatKeepsShrinkingRouteImport } from './routes/local-seo-in-a-map-pack-that-keeps-shrinking'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as ResultsRouteImport } from './routes/results'
import { Route as SchemaThatActuallyMovesTheNeedleRouteImport } from './routes/schema-that-actually-moves-the-needle'
import { Route as SeoAgencyChar123slugChar125RouteImport } from './routes/seo-agency-{$slug}'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as TheAnalyticsStackWeActuallyUseRouteImport } from './routes/the-analytics-stack-we-actually-use'
import { Route as TopicalAuthorityAndClustersRouteImport } from './routes/topical-authority-and-clusters'
import { Route as AdminUnlockRouteImport } from './routes/admin.unlock'
import { Route as AuthorsSlugRouteImport } from './routes/authors.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossarySlugRouteImport } from './routes/glossary.$slug'
import { Route as GuidesIndexRouteImport } from './routes/guides.index'
import { Route as GuidesSlugRouteImport } from './routes/guides.$slug'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesSlugRouteImport } from './routes/industries.$slug'
import { Route as LocationsIndexRouteImport } from './routes/locations.index'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as PortfolioSlugRouteImport } from './routes/portfolio.$slug'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as ServicesSeoRouteImport } from './routes/services.seo'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsSlugRouteImport } from './routes/tools.$slug'
import { Route as AdminCanonicalIndexRouteImport } from './routes/admin.canonical.index'
import { Route as AdminConversionsIndexRouteImport } from './routes/admin.conversions.index'
import { Route as AdminMetaExperimentsIndexRouteImport } from './routes/admin.meta-experiments.index'
import { Route as AdminRumIndexRouteImport } from './routes/admin.rum.index'
import { Route as AdminWebhooksIndexRouteImport } from './routes/admin.webhooks.index'
import { Route as ServicesSlugIndexRouteImport } from './routes/services.$slug.index'
import { Route as ServicesSlugGuidesRouteImport } from './routes/services.$slug.guides'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AiOverviewsWhatChangedInSearch2026Route = AiOverviewsWhatChangedInSearch2026RouteImport.update({
            id: '/ai-overviews-what-changed-in-search-2026',path: '/ai-overviews-what-changed-in-search-2026',getParentRoute: () => rootRouteImport
          })
const AiSearchOptimizationGuideRoute = AiSearchOptimizationGuideRouteImport.update({
            id: '/ai-search-optimization-guide',path: '/ai-search-optimization-guide',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CoreWebVitals2026Route = CoreWebVitals2026RouteImport.update({
            id: '/core-web-vitals-2026',path: '/core-web-vitals-2026',getParentRoute: () => rootRouteImport
          })
const DallasSeoCaseStudyRoute = DallasSeoCaseStudyRouteImport.update({
            id: '/dallas-seo-case-study',path: '/dallas-seo-case-study',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const GeoSuccessMatrixExplainedRoute = GeoSuccessMatrixExplainedRouteImport.update({
            id: '/geo-success-matrix-explained',path: '/geo-success-matrix-explained',getParentRoute: () => rootRouteImport
          })
const HowToRankInAiOverviewsRoute = HowToRankInAiOverviewsRouteImport.update({
            id: '/how-to-rank-in-ai-overviews',path: '/how-to-rank-in-ai-overviews',getParentRoute: () => rootRouteImport
          })
const HowWeTurnedAroundCarageAutoRoute = HowWeTurnedAroundCarageAutoRouteImport.update({
            id: '/how-we-turned-around-carage-auto',path: '/how-we-turned-around-carage-auto',getParentRoute: () => rootRouteImport
          })
const IndustriesRoute = IndustriesRouteImport.update({
            id: '/industries',path: '/industries',getParentRoute: () => rootRouteImport
          })
const LocalSeoInAMapPackThatKeepsShrinkingRoute = LocalSeoInAMapPackThatKeepsShrinkingRouteImport.update({
            id: '/local-seo-in-a-map-pack-that-keeps-shrinking',path: '/local-seo-in-a-map-pack-that-keeps-shrinking',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const ResultsRoute = ResultsRouteImport.update({
            id: '/results',path: '/results',getParentRoute: () => rootRouteImport
          })
const SchemaThatActuallyMovesTheNeedleRoute = SchemaThatActuallyMovesTheNeedleRouteImport.update({
            id: '/schema-that-actually-moves-the-needle',path: '/schema-that-actually-moves-the-needle',getParentRoute: () => rootRouteImport
          })
const SeoAgencyChar123slugChar125Route = SeoAgencyChar123slugChar125RouteImport.update({
            id: '/seo-agency-{$slug}',path: '/seo-agency-{$slug}',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const TheAnalyticsStackWeActuallyUseRoute = TheAnalyticsStackWeActuallyUseRouteImport.update({
            id: '/the-analytics-stack-we-actually-use',path: '/the-analytics-stack-we-actually-use',getParentRoute: () => rootRouteImport
          })
const TopicalAuthorityAndClustersRoute = TopicalAuthorityAndClustersRouteImport.update({
            id: '/topical-authority-and-clusters',path: '/topical-authority-and-clusters',getParentRoute: () => rootRouteImport
          })
const AdminUnlockRoute = AdminUnlockRouteImport.update({
            id: '/admin/unlock',path: '/admin/unlock',getParentRoute: () => rootRouteImport
          })
const AuthorsSlugRoute = AuthorsSlugRouteImport.update({
            id: '/authors/$slug',path: '/authors/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CaseStudiesRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossarySlugRoute = GlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => rootRouteImport
          })
const GuidesIndexRoute = GuidesIndexRouteImport.update({
            id: '/guides/',path: '/guides/',getParentRoute: () => rootRouteImport
          })
const GuidesSlugRoute = GuidesSlugRouteImport.update({
            id: '/guides/$slug',path: '/guides/$slug',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndustriesRoute
          })
const IndustriesSlugRoute = IndustriesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => IndustriesRoute
          })
const LocationsIndexRoute = LocationsIndexRouteImport.update({
            id: '/locations/',path: '/locations/',getParentRoute: () => rootRouteImport
          })
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
            id: '/portfolio/',path: '/portfolio/',getParentRoute: () => rootRouteImport
          })
const PortfolioSlugRoute = PortfolioSlugRouteImport.update({
            id: '/portfolio/$slug',path: '/portfolio/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const ServicesSeoRoute = ServicesSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => ServicesRoute
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsSlugRoute = ToolsSlugRouteImport.update({
            id: '/tools/$slug',path: '/tools/$slug',getParentRoute: () => rootRouteImport
          })
const AdminCanonicalIndexRoute = AdminCanonicalIndexRouteImport.update({
            id: '/admin/canonical/',path: '/admin/canonical/',getParentRoute: () => rootRouteImport
          })
const AdminConversionsIndexRoute = AdminConversionsIndexRouteImport.update({
            id: '/admin/conversions/',path: '/admin/conversions/',getParentRoute: () => rootRouteImport
          })
const AdminMetaExperimentsIndexRoute = AdminMetaExperimentsIndexRouteImport.update({
            id: '/admin/meta-experiments/',path: '/admin/meta-experiments/',getParentRoute: () => rootRouteImport
          })
const AdminRumIndexRoute = AdminRumIndexRouteImport.update({
            id: '/admin/rum/',path: '/admin/rum/',getParentRoute: () => rootRouteImport
          })
const AdminWebhooksIndexRoute = AdminWebhooksIndexRouteImport.update({
            id: '/admin/webhooks/',path: '/admin/webhooks/',getParentRoute: () => rootRouteImport
          })
const ServicesSlugIndexRoute = ServicesSlugIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesSlugRoute
          })
const ServicesSlugGuidesRoute = ServicesSlugGuidesRouteImport.update({
            id: '/guides',path: '/guides',getParentRoute: () => ServicesSlugRoute
          })





const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const IndustriesRouteChildren = {
  IndustriesSlugRoute: IndustriesSlugRoute,IndustriesIndexRoute: IndustriesIndexRoute
}

const IndustriesRouteWithChildren = IndustriesRoute._addFileChildren(IndustriesRouteChildren)




const ServicesSlugRouteChildren = {
  ServicesSlugGuidesRoute: ServicesSlugGuidesRoute,ServicesSlugIndexRoute: ServicesSlugIndexRoute
}

const ServicesSlugRouteWithChildren = ServicesSlugRoute._addFileChildren(ServicesSlugRouteChildren)



const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRouteWithChildren,ServicesSeoRoute: ServicesSeoRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AboutRoute: AboutRoute,AiOverviewsWhatChangedInSearch2026Route: AiOverviewsWhatChangedInSearch2026Route,AiSearchOptimizationGuideRoute: AiSearchOptimizationGuideRoute,CaseStudiesRoute: CaseStudiesRouteWithChildren,ContactRoute: ContactRoute,CoreWebVitals2026Route: CoreWebVitals2026Route,DallasSeoCaseStudyRoute: DallasSeoCaseStudyRoute,FaqRoute: FaqRoute,GeoSuccessMatrixExplainedRoute: GeoSuccessMatrixExplainedRoute,HowToRankInAiOverviewsRoute: HowToRankInAiOverviewsRoute,HowWeTurnedAroundCarageAutoRoute: HowWeTurnedAroundCarageAutoRoute,IndustriesRoute: IndustriesRouteWithChildren,LocalSeoInAMapPackThatKeepsShrinkingRoute: LocalSeoInAMapPackThatKeepsShrinkingRoute,PricingRoute: PricingRoute,ResourcesRoute: ResourcesRoute,ResultsRoute: ResultsRoute,SchemaThatActuallyMovesTheNeedleRoute: SchemaThatActuallyMovesTheNeedleRoute,SeoAgencyChar123slugChar125Route: SeoAgencyChar123slugChar125Route,ServicesRoute: ServicesRouteWithChildren,TheAnalyticsStackWeActuallyUseRoute: TheAnalyticsStackWeActuallyUseRoute,TopicalAuthorityAndClustersRoute: TopicalAuthorityAndClustersRoute,AdminUnlockRoute: AdminUnlockRoute,AuthorsSlugRoute: AuthorsSlugRoute,GlossarySlugRoute: GlossarySlugRoute,GuidesSlugRoute: GuidesSlugRoute,PortfolioSlugRoute: PortfolioSlugRoute,ToolsSlugRoute: ToolsSlugRoute,BlogIndexRoute: BlogIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,GuidesIndexRoute: GuidesIndexRoute,LocationsIndexRoute: LocationsIndexRoute,PortfolioIndexRoute: PortfolioIndexRoute,ToolsIndexRoute: ToolsIndexRoute,AdminCanonicalIndexRoute: AdminCanonicalIndexRoute,AdminConversionsIndexRoute: AdminConversionsIndexRoute,AdminMetaExperimentsIndexRoute: AdminMetaExperimentsIndexRoute,AdminRumIndexRoute: AdminRumIndexRoute,AdminWebhooksIndexRoute: AdminWebhooksIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)